import {getAccessToken} from 'infra/http/utils';
import {parseJwt} from './parseJwt';

interface UserTokenInfo {
	cdUsuario: string;
	cdPessoa: string;
}

export function getUserInfoFromToken(): UserTokenInfo {
	const accessToken = getAccessToken();

	if (!accessToken)
		return {
			cdUsuario: '',
			cdPessoa: '',
		};

	const parsedAccessToken = parseJwt(accessToken);
	const cdUsuario = parsedAccessToken?.data?.cdUsuario;
	const cdPessoa = parsedAccessToken?.data?.cdPessoa;

	return {cdUsuario, cdPessoa};
}
